import { Territory } from 'src/ducks/types'
import { formatParams } from 'src/helpers'
import axios from '../axios'
import { ApiController } from './types'

const base = '/territories'

const apiController: ApiController = {
  getTerritories: async ({ start, limit, searchParams }) => {
    const params = new URLSearchParams();

    if (start !== undefined) params.set('start', String(start));
    if (limit !== undefined) params.set('limit', String(limit));

    if (searchParams) {
      const { isServiceable, hasDocusignContract, search } = searchParams;
      if (isServiceable !== undefined) params.set('isServiceable', String(isServiceable));
      if (hasDocusignContract !== undefined) params.set('hasDocusignContract', String(hasDocusignContract));
      if (search) params.set('search', search);
    }

    return await axios
      .get(`${base}?${params.toString()}`)
      .then(response => response.data);
  },
  getTerritoryRepairItems: async ({ params, territoryId }) => {
    const parameters = formatParams(params)
    return await axios
      .get(`${base}/${territoryId}/repairItems?${parameters}`)
      .then(response => response.data)
  },
  getTerritoryById: async (id: string) =>
    await axios
      .get(`${base}/${id}`)
      .then(response => response.data),
  createTerritory: async (payload: Partial<Territory>) =>
    await axios
      .post(`${base}`, payload)
      .then(response => response.data),
  deleteTerritory: async (id: string) =>
    await axios
      .delete(`${base}/${id}`)
      .then(response => response.data),
  updateTerritory: async (id: string, request) =>
    await axios
      .patch(`${base}/${id}`, request)
      .then(response => response.data),


}

export default apiController
